import { t } from '../../../../common/components/T';

export const getDateWebConfig = (attribute, changeHandler, disabled, val, maxDate, minDate, showTimeSelect, openToDate) => ({
    ...(showTimeSelect ? { onChange: changeHandler } : { onSelect: changeHandler }),
    id: attribute,
    selected: val,
    disabled: Boolean(disabled),
    value: val,
    maxDate,
    minDate,
    startDate: maxDate,
    showTimeSelect: showTimeSelect,
    openToDate: openToDate
});

export const getFormattedDate = (dating, execludeYear, settings, lang) => {
    switch (settings?.date_format) {
        case '0':
            if (execludeYear) {
                let string = dating.locale(lang).format('MMMM DD');
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
            let string = dating.locale(lang).format('MMMM DD, YYYY');
            return string.charAt(0).toUpperCase() + string.slice(1);
        case '1':
            if (execludeYear) {
                return dating.format('MM-DD');
            }
            return dating.format('YYYY-MM-DD');
        case '2':
            if (execludeYear) {
                return dating.format('MM/DD');
            }
            return dating.format('MM/DD/YYYY');
        case '3':
            if (execludeYear) {
                return dating.format('DD.MM');
            }
            return dating.format('DD.MM.YYYY');
        default:
            if (execludeYear) {
                return dating.format('DD.MM');
            }
            return dating.format('DD.MM.YYYY');
    }
};

export const getDatePlaceholder = (settings, execludeYear, transl) => {
    switch (settings?.date_format) {
        case '0':
            if (execludeYear) {
                return t('FormDate-Date1-no-year', 'М дд', 'widget', transl, 'form');
            }
            return t('FormDate-Date1', 'М дд, год', 'widget', transl, 'form');
        case '1':
            if (execludeYear) {
                return t('FormDate-Date2-no-year', 'мм-дд', 'widget', transl, 'form');
            }
            return t('FormDate-Date2', 'гггг-мм-дд', 'widget', transl, 'form');
        case '2':
            if (execludeYear) {
                return t('FormDate-Date3-no-year', 'мм/дд', 'widget', transl, 'form');
            }
            return t('FormDate-Date3', 'мм/дд/гггг', 'widget', transl, 'form');
        case '3':
            if (execludeYear) {
                return t('FormDate-Date4-no-year', 'дд.мм', 'widget', transl, 'form');
            }
            return t('FormDate-Date4', 'дд.мм.гггг', 'widget', transl, 'form');
        default:
            if (execludeYear) {
                return t('FormDate-Date4-no-year', 'дд.мм', 'widget', transl, 'form');
            }
            return t('FormDate-Date4', 'дд.мм.гггг', 'widget', transl, 'form');
    }
};
